import { IProjectCompletionsParmetersCompletionDesign } from '../../interfaces/iproject-completions-parmeters-completion-design';
import { CompletionDesign } from '../completion-design';
import { ProjectCompletionsParameter } from '../project-completions-parameter';

export class ProjectCompletionsParmetersCompletionDesignBase {
  ProjectCompletionsParmetersCompletionDesignId: number;
  ProjectCompletionsParmeterId: number | null;
  CompletionDesignId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CompletionDesign?: CompletionDesign;
  ProjectCompletionsParameter?: ProjectCompletionsParameter;

  constructor(item?: IProjectCompletionsParmetersCompletionDesign) {
    if (item) {

      this.ProjectCompletionsParmetersCompletionDesignId = item.ProjectCompletionsParmetersCompletionDesignId;
      this.ProjectCompletionsParmeterId = item.ProjectCompletionsParmeterId;
      this.CompletionDesignId = item.CompletionDesignId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CompletionDesign = new CompletionDesign(item.CompletionDesign);
      this.ProjectCompletionsParameter = new ProjectCompletionsParameter(item.ProjectCompletionsParameter);
    }
  }
}